import { useState } from "react"
import ContextMenu from "./menu"
import ContextMenuStore, { Creator } from "./store"

const useContextMenu = <T,>(creator: Creator<T>) => {
  const [ contextMenu ] = useState(() => new ContextMenuStore(creator))
  return contextMenu
}

export { ContextMenu, ContextMenuStore, useContextMenu }